import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  inject
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { HtmlQuestionV3 } from '../../../classes/question-html';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';
import { CoreUtilsService } from '@bepatient/core';
import { ThemeService } from '../../../../services/theme.service';

@Component({
  selector: 'bepatient-input-html-v3',
  templateUrl: './input-html.component.html',
  styleUrls: ['./input-html.component.scss'],
  standalone: false
})
export class InputHtmlComponentV3
  extends QuestionBaseV3ComponentDirective
  implements OnInit, OnDestroy
{
  private sanitizer = inject(DomSanitizer);
  private coreUtilsService = inject(CoreUtilsService);
  private themeService = inject(ThemeService);
  private cdr = inject(ChangeDetectorRef);

  @Input() question: HtmlQuestionV3;
  @Input() color: string;
  safeHtml: SafeHtml;
  css: any = {};
  private themeSub?: Subscription;

  ngOnInit() {
    if (this.question.isHeadline && this.question.text) {
      this.question.text = this.question.text.toUpperCase();
    }
    this.applyThemeColors();

    // Re-adjust inline colors on every theme / high-contrast toggle so the
    // HTML content stays readable without a page reload. Recomputed from the
    // raw `question.css` / `question.text` (never from an adjusted value).
    this.themeSub = this.themeService.themeChange$.subscribe(() => {
      this.applyThemeColors();
      this.cdr.markForCheck();
    });
  }

  private applyThemeColors(): void {
    this.css = this.question.css
      ? this.coreUtilsService.adjustCssObjectColorsForTheme(
          this.question.css
        ) ?? this.question.css
      : {};

    const adjustedHtml =
      this.coreUtilsService.adjustInlineColorsForTheme(this.question.text) ??
      this.question.text ??
      '';
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(adjustedHtml);
  }

  ngOnDestroy(): void {
    this.themeSub?.unsubscribe();
  }
}
